export function OfficeTaskIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width={18}
            height={20}
            viewBox="0 0 512 512"
        >
            <g>
                <path
                    d="M96 480h320c17.67 0 32-14.33 32-32V128L352 32H96c-17.67 0-32 14.33-32 32v384c0 17.67 14.33 32 32 32zm224-416 64 64h-64zM112 96h176v64c0 17.67 14.33 32 32 32h64v224H112z"
                    fill="#000000"
                    opacity={1}
                    data-original="#000000"
                    className=""
                />
                <path
                    d="M160 256h192v32H160zM160 320h192v32H160zM160 192h128v32H160z"
                    fill="#000000"
                    opacity={1}
                    data-original="#000000"
                />
            </g>
        </svg>
    );
}